<template>
    <div class="form-overlay music-content" :class="position">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" :ref="`music-preview`"></audio>
        <div class="steep1" v-if="musicSelected">
            <div class="content">
                <div class="list-item hide-scrollbar">
                    <!-- <span class="loader" v-if="false"></span> -->
                    <div class="item">
                        <div class="img" @click.stop="toogleMusic(musicSelected)" :class="{play : urlMusicPlaying == musicSelected.track.progressive_download_url}">
                            <img :src="musicSelected.track.cover_artwork_thumbnail_uri" alt="">
                        </div>
                        
                        <div class="info">
                            <p class="name">{{musicSelected.track.title}}</p>
                            <p class="author">{{musicSelected.track.display_artist}}</p>
                        </div>
                        <i class="fa-regular fa-xmark" @click="removeMusic"></i>
                    </div>
                
                </div>
            </div>
        </div>
        
        <div class="steep2" v-else>
            <div class="content">
                <div class="input">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input musicholder="Rechercher une musique" v-model="textSearch" v-on:keyup.enter="sendSearchMusic">
                </div>

                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <div class="item" v-else v-for="(music, index) in listMusicsAvailable" @click="selectMusic(music)" :key="`music${index}`">
                        <div class="img" @click.stop="toogleMusic(music)" :class="{play : urlMusicPlaying == music.track.progressive_download_url}">
                            <img :src="music.track.cover_artwork_thumbnail_uri" alt="">
                        </div>
                        
                        <div class="info">
                            <p class="name">{{music.track.title}}</p>
                            <p class="author">{{music.track.display_artist}}</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="btn-secondary" @click="$emit('close')">Fermer</div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import musicsDefault from './musicDefault.js';
    export default {
        props: {
            musicSelected: {
                type: Object,
                default: undefined 
            },
            position: {
                type: String,
                default: 'left'
            },
        },

        data() {
            return {
                textSearch : 'summer',
                lastIdEvent : 0,
                stateLoader : false,
                listMusicsAvailable : musicsDefault,
                timeoutInitSearch : null,
                urlMusicPlaying : null,
            }
        },

        mounted () {
            EventBus.$on('resultSearchFromSelectMusic', this.receveidMusic);
        },

        methods: {
            sendSearchMusic() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchFromSelectMusic",this.textSearch,this.lastIdEvent)
            },

            receveidMusic(musics,idEvent) {
                if (this.lastIdEvent == idEvent) {
                    this.listMusicsAvailable = musics
                    this.stateLoader = false
                }
            },

            selectMusic(music) {
                if (this.urlMusicPlaying !== music.track.progressive_download_url) this.toogleMusic()
                EventBus.$emit("eventClickSelectMusic",music)
            },

            removeMusic() {
                this.toogleMusic()
                EventBus.$emit("eventRemoveSelectMusic")
            },
      
            toogleMusic(music) {
                let audio = this.$refs['music-preview'];

                if (!music) {
                    this.urlMusicPlaying = null;
                    audio.pause();
                    return;
                }

                if (music.track.progressive_download_url === audio.src) {
                    if (audio.paused) {
                        audio.play();
                        this.urlMusicPlaying = music.track.progressive_download_url;
                    } else {
                        audio.pause();
                        this.urlMusicPlaying = null;
                    }
                } else {
                    audio.src = music.track.progressive_download_url;
                    audio.currentTime = music.track.highlight_start_times_in_ms[0] / 1000;
                    this.urlMusicPlaying = music.track.progressive_download_url;
                    audio.play();
                }
            }
        },



        watch: {
            textSearch(newValue, oldValue) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.toogleMusic()
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchMusic()
                },1000)
            },
        },

        beforeDestroy () {
            EventBus.$off('resultSearchFromSelectMusic', this.receveidMusic);
        }
    }
</script>

